
const ProjectBlobClient = (props) => {
    
    var local = new Date(props.project.due_date);
    var offset = local.getTimezoneOffset();
    var due_date = new Date(local.getTime() + offset * 60000);

    function convertCurrencyToDouble(currency, locale = 'en-US', currencyType = 'USD') {
        // Creating a NumberFormat object with specified locale and currency
        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyType,
            currencyDisplay: 'symbol'
        });
    
        // Formatting the currency to remove any non-numeric characters except for decimal point
        const normalizedCurrency = currency.replace(/[^\d.-]+/g, "");
    
        // Converting the normalized string to a double value using Number constructor
        const doubleValue = Number(normalizedCurrency);
    
        // Returning the double value
        return doubleValue;

    }

    const fee = convertCurrencyToDouble(props.project.fee)
    const paid = convertCurrencyToDouble(props.project.paid)

    const statusColorMap = {
        "Not Started":        "#DC0000",
        "Awaiting Assets":    "#FF3300",
        "In Progress":        "#ff7700",
        "Awaiting Feedback":  "#ffb200",
        "Revising":           "#ffee00",
        "Mastering":          "#B2DF00",
        "Delivering":         "#46C408",
        "Complete":           "#00a116",
    };
    const accentColor = statusColorMap[props.project.status] || "#444";

    let statusColor = (function () {
        switch (props.project.status){
            case "Not Started":       return "not_started";
            case "Awaiting Assets":   return "assets";
            case "In Progress":       return "wip";
            case "Awaiting Feedback": return "feedback";
            case "Revising":          return "revising";
            case "Mastering":         return "mastering";
            case "Delivering":        return "delivering";
            case "Complete":          return "complete";
            default:                  return "";
        }
    })();

    return (
        <div className="projectBlobNarrow gradientWhite rounded-lg px-4 py-2 hoverLeft"
             style={{ borderLeft: `3px solid ${accentColor}` }}>
            <div className="flex flex-col gap-1">
                <div className="grid grid-cols-6 text-xs items-center">
                    <h4 className="text-[#e0e0e0] col-span-4 overflow-hidden text-nowrap text-ellipsis font-medium">
                        {props.project.title}
                    </h4>
                    <div className="text-[9px] font-medium text-nowrap text-[#555] col-span-2 text-right">
                        Due {due_date.toDateString()}
                    </div>
                </div>
                <div className="flex flex-row gap-2 text-[9px]">
                    <div className={statusColor + " justify-center items-center flex px-2 py-0.5 rounded-full uppercase font-bold tracking-wide"}>
                        {props.project.status}
                    </div>
                    {paid >= fee &&
                        <div className="flex items-center px-2 py-0.5 rounded-full uppercase font-bold tracking-widest text-[7px]"
                             style={{ color: '#46C408', background: 'rgba(70,196,8,0.15)', border: '1px solid rgba(70,196,8,0.35)' }}>
                            Paid
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default ProjectBlobClient